/* Generic PHP integration — auto-discovered by registry */
import type { FrameworkConfig } from '../../lib/framework-config.js';
import type { InstallerOptions } from '../../utils/types.js';
import { enableDebugLogs } from '../../utils/debug.js';

export const config: FrameworkConfig = {
  metadata: {
    name: 'PHP',
    integration: 'php',
    docsUrl: 'https://github.com/workos/workos-php',
    skillName: 'workos-php',
    language: 'php',
    stability: 'experimental',
    priority: 44,
    packageManager: 'composer',
    manifestFile: 'composer.json',
  },

  detection: {
    packageName: 'php',
    packageDisplayName: 'PHP',
    getVersion: () => undefined,
  },

  environment: {
    uploadToHosting: false,
    requiresApiKey: true,
    getEnvVars: (apiKey: string, clientId: string) => ({
      WORKOS_API_KEY: apiKey,
      WORKOS_CLIENT_ID: clientId,
    }),
  },

  analytics: {
    getTags: () => ({}),
  },

  prompts: {},

  ui: {
    successMessage: 'WorkOS AuthKit integration complete',
    getOutroChanges: () => [
      'Analyzed your PHP project structure',
      'Installed and configured WorkOS PHP SDK',
      'Created authentication endpoint files',
    ],
    getOutroNextSteps: () => [
      'Start your PHP development server to test authentication',
      'Visit the WorkOS Dashboard to manage users and settings',
    ],
  },
};

export async function run(options: InstallerOptions): Promise<string> {
  if (options.debug) {
    enableDebugLogs();
  }

  const { runAgentInstaller } = await import('../../lib/agent-runner.js');
  return runAgentInstaller(config, options);
}
